import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

@Injectable()
export class SynergoRequisitionService extends WebService {

    public getSynergoRequisition (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('employee,company,venue,profile_survey,citation,requisition_justification.user.employee,requisition_task.employee,requisition_task.created_by'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-requisitions?${params}`, options);
    }

    public getSynergoRequisitionByCustomerGuide (id: number,
        page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('employee,company,venue,profile_survey,citation,requisition_justification.user.employee,requisition_task.employee,requisition_task.created_by'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/customer-guides/${id}/synergo-requisitions?${params}`, options);
    }


    public newSynergoRequisition(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/synergo-requisitions`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateSynergoRequisition(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/synergo-requisitions/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteSynergoRequisition(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/synergo-requisitions/${id}`, { headers: this.headers } );
    }

    public infoSynergoRequisition(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        // params.append('_sort', String('-newnesses.created_at'));
        // params.append('_with', String('station,newnesses.user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-requisitions?${params}`,  options );
    }

    public getResumeSynergoRequisition (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-requisitions/resume?${params}`, options);
    }    
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/synergo-requisition/synergo-requisition.service.ts